import React from 'react'
import Link from 'gatsby-link'
import headerImage from './header.jpg'

const Header = () => (
  <header
    style={{
      backgroundImage: `url(${headerImage})`,
      backgroundSize: 'cover',
      marginBottom: '2rem',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '2.45rem 1.0875rem',
      }}
    >
      {/* <h1 style={{ margin: 0 }}> */}
      <Link className="page-title" to="/">
        Shahab Lashkari <span>Trying to make the web better</span>
      </Link>
      {/* </h1> */}
    </div>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js